import Image from 'next/image'
import { useRouter } from 'next/navigation'

import { popUpBanner } from '@/libs/constants/images-library'

const SliderItem = ({
  title,
  description,
  image,
}: {
  title: string
  description: string
  image: {
    src: string
    alt: string
  }
}) => {
  const router = useRouter()

  return (
    <div className='relative flex h-full w-full flex-col items-center md:justify-center lg:max-w-md'>
      <button
        type='button'
        aria-label='banner'
        className='relative flex h-fit w-full justify-center'
        onClick={() => router.push('/demo')}
      >
        <Image
          src={image.src}
          height={300}
          width={320}
          alt={image.alt}
          className='h-[300px] w-full flex-1 !object-contain md:max-w-md'
          objectFit='contain'
          priority
          fetchPriority='high'
          loading='eager'
        />
        <Image
          src={popUpBanner.src}
          alt={popUpBanner.alt}
          width={211}
          height={80}
          className='absolute bottom-0'
          priority
          fetchPriority='high'
          loading='eager'
        />
      </button>
      <div className='z-10 max-w-xs md:max-w-[500px] lg:!max-w-sm'>
        <h3 className='text-center text-2xl font-semibold text-white md:text-3xl'>{title}</h3>
        <p className='text-center text-md-regular font-normal text-white'>{description}</p>
      </div>
    </div>
  )
}

export default SliderItem
